import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './StaticPages.css';
const API_URL = process.env.REACT_APP_API_URL;
const ContactPage = () => {
    const { t, i18n } = useTranslation();
    const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
    const [status, setStatus] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setStatus('');
        setError('');

        try {
            const response = await fetch(`${API_URL}/api/public/contact`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ ...formData, language: i18n.language })
            });
            const data = await response.json();
            if (!response.ok) {
                throw new Error(t(data.messageKey) || t('contact_form_error'));
            }
            setStatus('success');
            setFormData({ name: '', email: '', subject: '', message: '' }); // Formu temizle
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-container static-page contact-page">
            <div className="static-header">
                <h1>{t('contact_title')}</h1>
                <p>{t('contact_subtitle')}</p>
            </div>
            <div className="contact-grid">
                <div className="contact-form-container">
                    <h3>{t('contact_form_title')}</h3>
                    <form onSubmit={handleSubmit} className="contact-form">
                        <div className="form-row-auth">
                            <div className="form-group-auth floating-label half-width">
                                <input id="name" name="name" type="text" value={formData.name} onChange={handleChange} required placeholder=" " />
                                <label htmlFor="name">{t('your_name')}</label>
                            </div>
                            <div className="form-group-auth floating-label half-width">
                                <input id="email" name="email" type="email" value={formData.email} onChange={handleChange} required placeholder=" " />
                                <label htmlFor="email">{t('your_email')}</label>
                            </div>
                        </div>
                        <div className="form-group-auth floating-label">
                            <input id="subject" name="subject" type="text" value={formData.subject} onChange={handleChange} required placeholder=" " />
                            <label htmlFor="subject">{t('subject')}</label>
                        </div>
                        
                        <div className="form-group-auth floating-label">
                            <textarea id="message" name="message" value={formData.message} onChange={handleChange} required placeholder=" " rows="5"></textarea>
                            <label htmlFor="message">{t('your_message')}</label>
                        </div>
                        
                        <button type="submit" className="cta-button primary" disabled={loading}>
                            {loading ? t('sending_message') : t('send_message')}
                        </button>
                        
                        {status === 'success' && <p className="form-success-message">{t('contact_form_success')}</p>}
                        {error && <p className="auth-error">{error}</p>}
                    </form>
                </div>
                <div className="contact-info-panel">
                    <h3>{t('direct_contact')}</h3>
                    <ul className="contact-details-list">
                        <li>
                            <i className="fas fa-map-marker-alt"></i>
                            <div>
                                <strong>{t('address')}</strong>
                   
                                <p>{t('company_address')}</p>
                            </div>
                        </li>
                        <li>
                            <i className="fas fa-envelope"></i>
                            <div>
                                <strong>{t('email')}</strong>
                           
                                <p><a href="mailto:info@quadlingua.com">info@quadlingua.com</a></p>
                            </div>
                        </li>
                        <li>
                            <i className="fas fa-phone"></i>
                            <div>
                                <strong>{t('phone')}</strong>
                             
                                <p><a href="tel:+905545821717">+90 554 582 17 17</a></p>
                            </div>
                        </li>
                    </ul>
                    <div className="social-links">
                        <h4>{t('follow_us')}</h4>
                      <div className="social-icons">
                        <a href={t('social_linkedin_url')} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="fa-brands fa-linkedin-in"></i></a>
						<a href={t('social_twitter_url')} target="_blank" rel="noopener noreferrer" aria-label="Twitter"><i className="fa-brands fa-twitter"></i></a>
						<a href={t('social_bluesky_url')} target="_blank" rel="noopener noreferrer" aria-label="Bluesky"><i className="fa-brands fa-bluesky"></i></a>
						<a href={t('social_facebook_url')} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fa-brands fa-facebook-f"></i></a>
                        <a href={t('social_instagram_url')} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fa-brands fa-instagram"></i></a>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactPage;